/** Mínimo de confianza de la IA para aplicar rotación automática (alineado con backend). */
export const UMBRAL_CONF_ORIENTACION = 0.85;

const ROTACIONES_VALIDAS = [0, 90, 180, 270];

export function normalizarRotacionGrados(n) {
  const v = Number(n);
  return ROTACIONES_VALIDAS.includes(v) ? v : 0;
}

/**
 * @param {object} s sugerencia de página (API auto-etiquetado)
 * @returns {number|null} grados a aplicar o null si no procede
 */
export function rotacionAplicableDesdeSugerencia(s) {
  const conf =
    typeof s?.confianzaOrientacion === 'number' ? s.confianzaOrientacion : 0;
  if (conf < UMBRAL_CONF_ORIENTACION) return null;
  return normalizarRotacionGrados(s?.rotacionGrados ?? 0);
}

/**
 * @param {object} s
 * @returns {{ orden: number, motivo: string } | null}
 */
export function motivoRevisionOrientacion(s) {
  if (s?.errorMensaje) {
    return {
      orden: s.orden,
      motivo: `Error de análisis: ${s.errorMensaje}`,
    };
  }
  const conf =
    typeof s?.confianzaOrientacion === 'number' ? s.confianzaOrientacion : null;
  if (conf === null || conf < UMBRAL_CONF_ORIENTACION) {
    const pct =
      conf === null ? 'desconocida' : `${Math.round(conf * 100)} % (mínimo 85 %)`;
    return {
      orden: s.orden,
      motivo: `Orientación con confianza ${pct}`,
    };
  }
  return null;
}

/**
 * @param {object} s
 * @param {number|null} rotacionAplicada
 */
export function buildDecisionAplicarSugerencia(s, rotacionAplicada) {
  const decision = {
    instrumentosVoces: s.instrumentosVoces,
    tituloObra: s.tituloObra,
    autor: s.autor,
    notasDirector: s.notasDirector,
  };
  if (rotacionAplicada !== null && rotacionAplicada !== undefined) {
    decision.rotacion = rotacionAplicada;
  }
  return decision;
}
